/* eslint-disable @typescript-eslint/no-empty-function */
import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseFormFieldComponent } from '../base-form-field.component';

@Component({
  standalone: false,
  selector: 'ideapa-attachment-field',
  template: `
    <ideapa-form-field-wrapper
      [label]="label"
      [shouldShowError]="shouldShowError"
      [errors]="errors"
      [tooltip]="tooltip"
    >
      <ideapa-file-reader
        [accept]="accept"
        [multiple]="multiple"
        [formControl]="formControl"
        [maximumSizeMB]="10"
      >
      </ideapa-file-reader>
    </ideapa-form-field-wrapper>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AttachmentFieldComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentFieldComponent extends BaseFormFieldComponent {
  @Input()
  multiple = false;

  @Input()
  accept = '*';
}
